// @flow

import React from 'react'

import Button from '../Button'

import logoAfp from '../../assets/images/logo_afp.svg'
import logoWithBaseline from '../../assets/images/logo_with_baseline.svg'
import './styles.css'

type styleType = { opacity: 0 | 1, display: 'block' | 'none' }

type PropsType = {
  percent: number,
  hideLoader: (firstAppearance: boolean, animationDuration: number) => void,
  visible: boolean,
  setCanAnimate: (canAnimate: boolean) => void
}

type StateType = {
  moment: 'baseline' | 'logo',
  firstAppearance: boolean,
  baselineStyle: styleType,
  logoStyle: styleType,
  containerStyle: { opacity: 0 | 1 }
}

export default class Loader extends React.Component<PropsType, StateType> {
  constructor(props: PropsType) {
    super(props)
    this.state = {
      moment: 'baseline',
      firstAppearance: true,
      baselineStyle: { opacity: 1, display: 'block'  },
      logoStyle: { opacity: 0, display: 'none' },
      containerStyle: { opacity: 1 }
    }
    
    setTimeout(() => {
      this.makeBaselineDisappear()
    }, 5000);
  }

  makeBaselineDisappear = () => {
    this.setState({ baselineStyle: { opacity: 0, display: 'block' } })
    setTimeout(() => {
      this.makeLogoAppear()
    }, 1000);
  }

  makeLogoAppear = () => {
    this.setState({ baselineStyle: { opacity: 0, display: 'none' }, logoStyle: { opacity: 0, display: 'block' } })
    setTimeout(() => {
      this.setState({ logoStyle: { opacity: 1, display: 'block' } })      
    }, 100);
  }

  enterHome = () => {
    this.setState({
      baselineStyle: { opacity: 0, display: 'none' },
      logoStyle: { opacity: 0, display: 'block' },
      containerStyle: { opacity: 0 }
    })
    this.hideLoader()
  }

  hideLoader = () => {
    this.props.hideLoader(this.state.firstAppearance, 1100)
    if (this.state.firstAppearance) this.setState({ firstAppearance: false })
  }


  render () {
    if (this.props.visible === false) return null
    return (
      <div className="loader-container" style={this.state.containerStyle}>
        <div className="loading-bar-container">
          <div className="loading-bar-hidder" style={{ height: `${100 - this.props.percent}%` }}/>
        </div>
        <div className="baseline" style={this.state.baselineStyle}>
          <img src={logoAfp} alt="logoAFP"/>
          <h3>Discover an important event each day through one photo from the best shots by AFP’s photographers.</h3>
        </div>
        <div className="logo" style={this.state.logoStyle}>
          <img src={logoWithBaseline} alt="logo-baseline"/>
          {this.props.percent === 100 &&
            <Button action={this.enterHome}>Discover</Button>
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Loader/index.jsx